// extracted by mini-css-extract-plugin
module.exports = {"u-fullWidth":"style_u-fullWidth__1wm9z","u-shrinkAll":"style_u-shrinkAll__1yqIX","Checkbox":"style_Checkbox__3GUH_","Checkbox--small--label":"style_Checkbox--small--label__1LV5b"};